import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Toolbar } from "@components-common/toolbar";
import { withFormik } from "../WithFormik.hoc";
import { FormProps } from "@components-common/forms";

export type PageFormContentProps = {
  form: any;
  toolbar: any;
};

const createForm = (formProps: FormProps) => {
  if (formProps?.el !== undefined) {
    return formProps.el;
  }
  if (formProps?.component !== undefined) {
    const { component: Component, ...rest } = formProps;
    return <Component {...rest} />;
  }
  return <></>;
};

const PageFormContentInner: FC<PageFormContentProps> = observer(
  (props: PageFormContentProps) => {
    const {
      form,
      toolbar,
    } = props as any;
    const resultForm = createForm(form);
    return (
      <>
        <Toolbar {...toolbar} />
        {resultForm}
      </>
    );
  }
);

export const PageFormContent = withFormik(PageFormContentInner);
